<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="6" class="d-flex justify-end">
        <v-btn-toggle class="ml-auto">
          <v-btn @click="ChangerLangue('fr')">
            <v-img
              src="@/assets/france-flag-icon.svg"
              contain
              max-height="25"
            />
          </v-btn>
          <v-btn @click="ChangerLangue('en')">
            <v-img
              src="@/assets/english-flag-icon.svg"
              contain
              max-height="25"
            />
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog.erreur.model" width="500">
      <v-card class="text-center">
        <v-card-title class="justify-center">
          <h3>{{ $storeUm6p.Label.Informations }}</h3>
        </v-card-title>
        <v-card-text>
          <h5>
            {{ dialog.erreur.texte }}
          </h5>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="ecPrimary" text @click="dialog.erreur.model = false">
            {{ $storeUm6p.Label.Fermer }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.document.model" max-width="80%">
      <v-card>
        <v-toolbar color="ecSecondary" dark>
          <v-toolbar-title>
            {{ $storeUm6p.Label.Annexes.AjouterPj }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap xs12>
              <v-flex xs5>
                <v-autocomplete
                  class="pt-0"
                  v-model="editedItem.nomDocument"
                  :label="$storeUm6p.Label.Annexes.TypePiece"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.NomDocument"
                  readonly
                />
              </v-flex>
              <v-flex xs6>
                <!--cutom update button AGU-->
                <upload-btn
                  class="mr-10"
                  color="ecSecondary"
                  dark
                  :loading="uploadFileLoading"
                  :selectedFileName="editedItem.nomFichier"
                  :defaultButtonText="
                    $storeUm6p.Label.Annexes.SelectionnerDocument
                  "
                  ref="btnupload"
                  @file-update="selectFile"
                >
                </upload-btn>
                <small>{{ $storeUm6p.Label.Annexes.FormatsAcceptes }}</small>
                <br />
                <small>{{ $storeUm6p.Label.Annexes.TailleMaximale }}</small>

                <v-snackbar
                  :timeout="2000"
                  color="error"
                  elevation="24"
                  v-model="snackbar"
                >
                  {{ $storeUm6p.Label.Annexes.TailleMaximaleDepassee }}
                </v-snackbar>
              </v-flex>
              <v-flex xs1> </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
              <span v-if="editedItem.nomFichier">{{
                $storeUm6p.Label.Annexes.FichierSelectionne
              }}</span>
              <span
                v-if="editedItem.nomFichier"
                style="background-color: lightgray"
                >{{ editedItem.nomFichier }}</span
              >
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="close">{{
            $storeUm6p.Label.Annuler
          }}</v-btn>
          <v-btn
            color="success"
            dark
            :loading="uploadFileLoading"
            @click="save"
            >{{ $storeUm6p.Label.Valider }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert
      border="left"
      colored-border
      color="ecSecondary"
      elevation="1"
      v-show="$storeBourse.DonneesFormulaireEC.lienDocumentDgi"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationSalarie }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.Annexes.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeBourse.DonneesFormulaireEC.lienDocumentDgi
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-alert
      border="left"
      colored-border
      color="ecSecondary"
      elevation="1"
      v-show="$storeBourse.DonneesFormulaireEC.lienDocumentSalaire"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationDgi }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.Annexes.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeBourse.DonneesFormulaireEC.lienDocumentSalaire
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-data-table
      :headers="$storeUm6p.Label.Annexes.Header"
      :items="ListeAnnexes"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" :icon="icons.mdiAlert">{{
          $storeUm6p.Label.Annexes.ListeVide
        }}</v-alert>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <th class="text-xs-left">
            {{
              $storeCommun.ItemLang == "lang00"
                ? item.labelFormulaire
                : item.labelFormulaireEn
            }}
          </th>
          <th class="text-xs-left" style="color: red" v-if="!item.nomFichier">
            {{ $storeUm6p.Label.Annexes.FichierManquant }}
          </th>
          <th class="text-xs-left" v-else>
            {{ item.nomFichier }}
          </th>
          <th>
            {{
              item.obligatoireSoumettre
                ? $storeUm6p.Label.Oui
                : $storeUm6p.Label.Non
            }}
          </th>
          <th
            class="text-xs-left"
            style="color: red"
            v-if="
              item.conformiteElectronique?.id == 4251 ||
              item.conformiteElectronique?.id == 4299
            "
          >
            {{
              $storeCommun.ItemLang == "lang00"
                ? item.conformiteElectronique?.lang00
                : item.conformiteElectronique?.lang01
            }}
          </th>
          <th class="text-xs-left" v-else>
            {{
              $storeCommun.ItemLang == "lang00"
                ? item.conformiteElectronique?.lang00
                : item.conformiteElectronique?.lang01
            }}
          </th>
          <th>
            {{ item.nonConformeElectronique }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.valide"
              v-show="item.editable"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.urlFichier"
              small
              class="mr-2"
              :title="$storeUm6p.Label.Annexes.AfficherDocument"
              @click="$storeCommun.AfficherAnnexe(item.urlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.nomFichier && item.editable"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  mdiPencil,
  mdiEye,
  mdiClose,
  mdiDelete,
  mdiAlert,
  mdiFileDownload,
} from "@mdi/js";
import UploadButton from "@/components/CustomFileUpload";

export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiEye,
        mdiClose,
        mdiDelete,
        mdiFileDownload,
        mdiAlert,
      },
      loader: false,
      token: null,
      autorise: false,
      $storeUm6p: this.$storeUm6p,
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun: this.$storeCommun,
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeBourse : this.$storeBourse,
      // Dialog et flag
      dialog: {
        erreur: {
          model: false,
          texte: "",
        },
        document: {
          model: false,
          texte: "",
        },
      },
      uploadFileLoading: false,
      snackbar: false,
      editedIndex: -1,
      editedItem: {
        supprimer: false,
        idCrypte: null,
        anneeScolaire: {
          id: null,
          lang00: null,
          lang01: null,
        },
        conformiteElectronique: {
          id: null,
          lang00: null,
          lang01: null,
        },
        conformitePhysique: {
          id: null,
          lang00: null,
          lang01: null,
        },
        natureDocument: {
          id: null,
          lang00: null,
          lang01: null,
        },
        nomDocument: {
          id: null,
          lang00: null,
          lang01: null,
        },
        nomFichier: null,
        donneePieceJointe: null,
        nonConformeElectronique: null,
        nonConformePhysique: null,
        candidatureBourseId: null,
        ppId: null,
        templateAnnexeFirsi: null,
        typeDeDocument: {
          id: null,
          lang00: null,
          lang01: null,
        },
        fratrie: null,
        situationFamiliale: null,
        etape: null,
      },

      pieceManquante: 1,
      index: 0,
    };
  },
  mounted() {
    // charger la liste des annexes
    let token = this.$route.query.t;
    if (token) {
      this.token = token.replace(/\s/g, "+");
      this.$storeBourse.AffecteToken(this.token);
    }
    this.$storeCatalogue.ChargerCataloguesAnnexes();
    this.ChargerAnnexes();
  },
  computed: {
    ListeAnnexes(){
      return this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi;
    }
  },
  methods: {
    async ChargerAnnexes() {
      this.loader = true;
      const reponse = await this.$storeBourse.GetFicheByToken(this.token);
      if (reponse) {
        this.loader = false;
        if (reponse.data.autorise === true) {
          this.$storeBourse.DonneesFormulaireEC = reponse.data;
        } else {
          this.$router.push("/NonConnecte");
        }
      }
    },
    ChangerLangue(langue) {
      // Mettre à jour la langue des rules
      this.$rules.lang = langue;
      if (langue === "en") {
        this.$storeUm6p.Label = this.$storeUm6p.LabelEN;
        this.$storeCommun.ItemLang = "lang01";
      } else {
        this.$storeUm6p.Label = this.$storeUm6p.LabelFR;
        this.$storeCommun.ItemLang = "lang00";
      }
    },
    editItem(item) {
      this.editedIndex =
        this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog.document.model = true;
    },
    deleteItem(item) {
      if (confirm(this.$storeUm6p.Label.Annexes.SupprimerDocument)) {
        // on récupère l'item depuis le store
        this.editedIndex =
          this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi.indexOf(item);
        // on affecte l'item local pour récupèrer les valeurs
        this.editedItem = Object.assign({}, item);
        let self = this;
        Promise.all([
          // Appel de l'api de suppression de la PJ
          this.$storeDemandeBourse
            .DeleteFichier(this.editedItem, this.token)
            .then((reponse) => {
              if (reponse) {
                this.$set(
                  this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi, 
                  this.editedIndex, 
                  reponse.data );
                }
            })
            .catch((error) => {
              console.log(error);
            }),
        ]).then(function () {
          // RAZ de editeditem
          self.close();
        });
      }
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size > 4173649) {
          this.editedItem.nomFichier = "";
          this.editedItem.donneePieceJointe = null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.editedItem.nomFichier = file.name;
          await this.readFile(file, this.editedItem);
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.editedItem.nomFichier = "";
        this.editedItem.donneePieceJointe = null;
      }
    },

    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        monFichier.donneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du fichier

      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },

    close() {
      this.dialog.document.model = false;
      setTimeout(() => {
        this.editedItem = Object.assign(
          {},
          {
            supprimer: false,
            idCrypte: null,
            anneeScolaire: {
              id: null,
              lang00: null,
              lang01: null,
            },
            conformiteElectronique: {
              id: null,
              lang00: null,
              lang01: null,
            },
            conformitePhysique: {
              id: null,
              lang00: null,
              lang01: null,
            },
            natureDocument: {
              id: null,
              lang00: null,
              lang01: null,
            },
            nomDocument: {
              id: null,
              lang00: null,
              lang01: null,
            },
            nomFichier: null,
            donneePieceJointe: null,
            nonConformeElectronique: null,
            nonConformePhysique: null,
            candidatureBourseId: null,
            ppId: null,
            templateAnnexeFirsi: null,
            typeDeDocument: {
              id: null,
              lang00: null,
              lang01: null,
            },
            fratrie: null,
            situationFamiliale: null,
            etape: null,
          }
        );
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        var self = this;
        this.uploadFileLoading = false;
        this.editedItem.supprimer = false;
        Promise.all([
          // Sauvegarder le fichier, appelle api
          this.$storeDemandeBourse
            .UploadFichier(this.editedItem, this.token)
            .then((reponse) => {
              if (reponse && reponse.data) {
                this.editedItem = reponse.data;
                this.$set(
                  this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi, 
                  this.editedIndex, 
                  this.editedItem );
              } else {
                console.log("annexe pas enregistrée");
              }
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            }),
        ]).then(function () {
          self.close();
          self.$refs.btnupload.resetClick();
        });
      }
    },
  },
};
</script>
